export default "__VITE_ASSET__DNCGQJZp__"